import React, { useState, Fragment, useEffect } from "react";
import CountryFlag from "../common/CountryFlag";

const FormInputPhoneNumber = ({
    name,
    placeholder,
    selectCountryPlaceholder,
    value,
    onChange,
    disabled,
    isInvalid,
    invalidMessage,
    countryCode,
    prefixPhoneNumber,
    handleClickCountryList
}) => {
    const [searchPhoneCode, setSearchPhoneCode] = useState(null);
    const [countriesData, setCountriesData] = useState([]);

    useEffect(() => {
        try {
            loadCountriesData();
        } catch (e) {
            console.log(e);
        }
    }, []);


    const selectedCountry = countriesData?.find(
        (item) => item.code === countryCode
    );

    const loadCountriesData = () => {
        fetch("/json/countries.json") // Replace with the actual path to your JSON file
            .then((response) => response.json())
            .then((data) => setCountriesData(data))
            .catch((error) => console.error("Error loading JSON data:", error));
    };

    return (
        <>
            <div className="input-group">
                <button
                    className="btn bg-gold-light-100 fw-100 rounded noto dropdown-toggle border-gold p noto-sans"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    disabled={disabled}
                >
                    <CountryFlag
                        code={countryCode}
                        emoji={selectedCountry?.flag}
                        alt={selectedCountry?.name}
                    />{" "}
                    ({prefixPhoneNumber})
                </button>
                <ul className="dropdown-menu">
                    <div className="px-1 align-items-center mb-3 dropdown-search">
                        <input
                            type="text"
                            className={`form-control p-3 mb-2`}
                            defaultValue={searchPhoneCode}
                            placeholder={selectCountryPlaceholder}
                            onChange={(e) =>
                                setSearchPhoneCode(e.target.value)
                            }

                        />
                    </div>
                    {
                        searchPhoneCode !== null ?
                            countriesData
                                ?.filter((item) => {
                                    const searchValue = searchPhoneCode?.toLowerCase() || "";
                                    return (
                                        item.name.toLowerCase().includes(searchValue) ||
                                        item.dial_code.toLowerCase().includes(searchValue)
                                    );
                                })
                                ?.map((country, index) => (
                                    <Fragment key={country.code}>
                                        <li
                                            className="dropdown-item m-0"
                                            onClick={() =>
                                                handleClickCountryList(
                                                    country.dial_code,
                                                    country.code,
                                                    country.name
                                                )
                                            }
                                        >
                                            <div className="row px-1 align-items-center">
                                                <div className="col-auto">
                                                    <div className="bg-secondary bg-opacity-25 px-1">
                                                        <CountryFlag
                                                            code={country.code}
                                                            emoji={country.flag}
                                                            alt={country.name}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    ({country.dial_code}) {country.name}
                                                </div>
                                            </div>
                                        </li>
                                        <hr className="my-1" />
                                    </Fragment>
                                )) :
                            countriesData
                                ?.map((country, index) => (
                                    <Fragment key={country.code}>
                                        <li
                                            className="dropdown-item m-0"
                                            onClick={() =>
                                                handleClickCountryList(
                                                    country.dial_code,
                                                    country.code,
                                                    country.name
                                                )
                                            }
                                        >
                                            <div className="row px-1 align-items-center">
                                                <div className="col-auto">
                                                    <div className="bg-secondary bg-opacity-25 px-1">
                                                        <CountryFlag
                                                            code={country.code}
                                                            emoji={country.flag}
                                                            alt={country.name}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    ({country.dial_code}) {country.name}
                                                </div>
                                            </div>
                                        </li>
                                        <hr className="my-1" />
                                    </Fragment>
                                ))
                    }
                </ul>
                <input
                    type="number"
                    className={`form-control contact-form p-3 ${isInvalid && "is-invalid"}`}
                    id="phoneNumber"
                    placeholder={placeholder}
                    name={name}
                    value={value}
                    onChange={(e) => onChange(e)}
                    disabled={disabled}
                    style={{
                        color: value ? "#282828" : "",
                        fontWeight: value ? "bold" : "",
                    }}
                />
                {isInvalid && (
                    <p className="text-danger">
                        {invalidMessage}
                    </p>
                )}

            </div>
        </>
    );
};

export default FormInputPhoneNumber;
